<template>
  <div>
    <InfoCards class="mb-5" :infoCards="infoCards" @getData="updateView" />

    <Card v-if="esRedencion">
      <v-card-text style="max-height: 85vh; overflow-y: auto;">
        <v-row>
          <v-col cols="12" md="10">
            <span class="titulo-redencion"
              >Redencion # {{ solicitudLocal.id }}</span
            >
            <span class="titulo-header"> {{ solicitudLocal.titulo }}</span>
          </v-col>
        </v-row>

        <div>
          <div ref="redencionSection">
            <RedencionForm
              mode="view"
              :solicitud="solicitudLocal"
              :showActions="true"
              showViewOnlyFields
            />
          </div>

          <div ref="clienteSection">
            <ClienteForm
              mode="view"
              :solicitud="solicitudLocal"
              :clientSave="clientSave"
            />
          </div>

          <div>
            <SeguimientoForm :solicitud="solicitudLocal" />
          </div>
        </div>
      </v-card-text>
    </Card>

    <Card v-else-if="esRetencion">
      <v-card-text style="max-height: 85vh; overflow-y: auto;">
        <v-row>
          <v-col cols="12" md="10">
            <span class="titulo-redencion"
              >Solicitud # {{ solicitudLocal.id }}</span
            >
            <span class="titulo-header"> {{ solicitudLocal.titulo }}</span>
          </v-col>
        </v-row>

        <div>
          <div ref="retencionSection">
            <RetencionForm
              mode="view"
              :solicitud="solicitudLocal"
              :showActions="true"
            />
          </div>

          <div ref="clienteSection">
            <ClienteForm
              mode="view"
              :solicitud="solicitudLocal"
              :clientSave="clientSave"
            />
          </div>

          <div>
            <SeguimientoForm :solicitud="solicitudLocal" />
          </div>
        </div>
      </v-card-text>
    </Card>

    <Card v-else>
      <v-card-text style="max-height: 85vh; overflow-y: auto;">
        <v-row>
          <v-col cols="12" md="10">
            <span class="titulo-redencion"
              >Solicitud # {{ solicitudLocal.id }}</span
            >
            <span class="titulo-header"> {{ solicitudLocal.titulo }} </span>
          </v-col>
        </v-row>

        <div>
          <div ref="generalSection">
            <GeneralForm
              :key="Math.random()"
              mode="view"
              :solicitud="solicitudLocal"
              :campaniasRaw="campaniasRaw"
              :tiposSolicitud="tiposSolicitud"
              :productosAseguradora="productosAseguradora"
            />
          </div>

          <div ref="clienteSection">
            <ClienteForm
              mode="view"
              :solicitud="solicitudLocal"
              :clientSave="clientSave"
            />
          </div>

          <div>
            <SeguimientoForm :solicitud="solicitudLocal" />
          </div>
        </div>
      </v-card-text>
    </Card>
  </div>
</template>

<script>
import InfoCards from "@/components/solicitudes/InfoCards.vue";
import RedencionForm from "@/components/solicitudes/forms/RedencionForm.vue";
import RetencionForm from "@/components/solicitudes/forms/RetencionForm.vue";
import ClienteForm from "@/components/solicitudes/forms/ClienteForm.vue";
import GeneralForm from "@/components/solicitudes/forms/GeneralForm.vue";
import Card from "@/components/commondComponents/Card.vue";
import SeguimientoForm from "@/components/solicitudes/forms/SeguimientoForm.vue";
import { getSolicitudById } from "@/services/solicitudService";
import { getAllCampaniasPostVenta } from "@/services/campaniasPostventa";
import { mainAxios } from "@/mainAxios";

export default {
  components: {
    RedencionForm,
    RetencionForm,
    ClienteForm,
    SeguimientoForm,
    Card,
    GeneralForm,
    InfoCards,
  },
  props: {},
  data() {
    return {
      solicitudLocal: {},
      rol: JSON.parse(localStorage.getItem("roles"))?.[0]?.rol || "",
      loading: false,
      redMode: "",
      clientMode: "view",
      clientSave: false,
      campaniasRaw: [],
      tiposSolicitud: [],
      productosAseguradora: [],
      infoCards: {
        notas: [],
        docs: [],
        logs: [],
      },
      routesConfigNoteCard: {
        route: "",
        action: "",
      },
    };
  },
  watch: {},
  async mounted() {
    this.loadSolicitud();
    await this.loadCampanias();
    this.getProductosAseguradora();
  },
  computed: {
    isViewMode() {
      return this.mode === "view";
    },
    esRedencion() {
      const tipo = this.solicitudLocal?.tipo;
      const resultado =
        tipo === "Redención Beneficio" || tipo === "Redención" || tipo === "Redención Asistencia";
      return resultado;
    },
    esRetencion() {
      const tipo = this.solicitudLocal?.tipo;
      const resultado = tipo === "Retención";
      return resultado;
    },
  },
  methods: {
    async loadSolicitud() {
      this.loading = true;
      try {
        const response = await getSolicitudById(this.$route.params.idSolicitud);
        this.solicitudLocal = response;
        this.mapSolicitudToInfoCards();
      } finally {
        this.loading = false;
      }
    },
    mapSolicitudToInfoCards() {
      const documentos = this.solicitudLocal.documentos || [];
      const logs = this.solicitudLocal.logs || [];

      this.infoCards = {
        notas: documentos.filter((doc) => doc.tipoRegistro === "Nota"),
        docs: documentos.filter((doc) => doc.tipoRegistro === "Documento"),
        logs: logs,
      };
    },
    async loadCampanias() {
      try {
        const res = await getAllCampaniasPostVenta();
        this.campaniasRaw = res || [];
        this.tiposSolicitud = [
          ...new Set(this.campaniasRaw.map((c) => c.tipificacion)),
        ];
      } catch (error) {
        console.error("Error al cargar campañas:", error);
      }
    },
    getProductosAseguradora() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios
        .get("v1/producto/productosAseguradora", config)
        .then((response) => {
          this.productosAseguradora = response.data.data.productos;
        });
    },
    updateView() {
      location.reload();
    },
  },
};
</script>

<style scoped>
.titulo-redencion {
  font-weight: 700;
  font-size: 32px;
  color: #130707;
  display: block;
  padding-bottom: 5px;
}
.titulo-header {
  font-weight: 600;
  font-size: 20px;
  display: block;
  margin-top: 4px;
}
</style>
